import React from 'react';
import TablePagination from '@mui/material/TablePagination';
import { ROWS_PER_PAGE_OPTIONS } from '../../hooks/useTablePagination/useTablePagination';

/**
 * Barra de paginación de listados, en español y con el selector de
 * tamaño de página (10 / 20 / 50) dentro del propio listado.
 *
 * `variant`:
 *  - "dark"    (default) para las páginas del panel admin, que pintan sus
 *              colores a mano (#e2e8f0 sobre fondo slate) en vez de usar
 *              el theme de MUI.
 *  - "default" para las pantallas que sí heredan el theme.
 */
const darkSx = {
  color: 'var(--wb-text)',
  borderTop: '1px solid var(--wb-border)',
  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    color: 'var(--wb-muted-85)',
    fontSize: '0.8125rem'
  },
  '& .MuiTablePagination-select, & .MuiTablePagination-selectIcon': { color: 'var(--wb-text)' },
  '& .MuiIconButton-root': { color: 'var(--wb-muted-85)' },
  '& .MuiIconButton-root.Mui-disabled': { color: 'var(--wb-border-30)' }
};

const TablePaginationBar = ({ variant = 'dark', hasMore = false, sx, ...props }) => (
  <TablePagination
    component="div"
    rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
    labelRowsPerPage="Filas por página:"
    labelDisplayedRows={({ from, to, count }) =>
      // `count` es lo cargado hasta ahora, no el total del listado: el
      // backend pagina con cursor y no sabe cuántas filas hay sin
      // recorrerlas todas. El "+" dice justamente eso.
      `${from}–${to} de ${count}${hasMore ? '+' : ''}`
    }
    getItemAriaLabel={(type) => ({
      first: 'Ir a la primera página',
      last: 'Ir a la última página',
      next: 'Ir a la página siguiente',
      previous: 'Ir a la página anterior'
    }[type])}
    sx={{ ...(variant === 'dark' ? darkSx : {}), ...sx }}
    {...props}
  />
);

export default TablePaginationBar;
